import { Skeleton } from "@chakra-ui/react";
import { NavBar } from "@components/ui-kit";
import { Trans, t } from "@lingui/macro";
import { Icon } from "@src/components/ui-kit/Icon";
import { useBrandNavigationPages } from "@src/components/widgets/AppSubNav/NavigationBrand/hooks";
import { useScreenType } from "@src/utils/hooks/useIsMobile";
import { observer } from "mobx-react-lite";
import { AppSubNav } from "../AppSubNav";

interface NavigationBrandProps {
  id: string;
  variant: "page" | "panel";
}

export const NavigationBrand = observer(function NavigationBrand({
  id,
  variant,
}: NavigationBrandProps) {
  const { isDesktop } = useScreenType();
  const { visiblePages, data, activePage } = useBrandNavigationPages(id);

  if (variant === "page") {
    return (
      <AppSubNav showWidgets={false}>
        {visiblePages.map((page) => (
          <NavBar.Item key={page.href.pathname} href={page.href}>
            {page.title()}
          </NavBar.Item>
        ))}
      </AppSubNav>
    );
  }

  return (
    <AppSubNav>
      <NavBar.Item href="/brands" active={false}>
        <Trans>Brands</Trans>
      </NavBar.Item>

      {isDesktop && <Icon name="chevron-right" />}

      <NavBar.Item
        href={{ pathname: "/brands/detail", query: { id } }}
        active={false}
      >
        <Skeleton isLoaded={!!data}>
          {data ? `${data?.name} (${data?.code})` : t`Detail`}
        </Skeleton>
      </NavBar.Item>

      {activePage && isDesktop && <Icon name="chevron-right" />}

      {activePage && (
        <NavBar.Item href={activePage.href} active={false}>
          {activePage.title()}
        </NavBar.Item>
      )}
    </AppSubNav>
  );
});
